import { NativeDateAdapter } from '@angular/material/core';

export class FrenchDateAdapter extends NativeDateAdapter {
  override parse(value: unknown): Date | null {
    if (typeof value !== 'string') {
      return super.parse(value);
    }

    const match = value.trim().match(/^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/);
    if (!match) {
      return super.parse(value);
    }

    const day = Number(match[1]);
    const month = Number(match[2]);
    const enteredYear = Number(match[3]);
    const year =
      match[3].length === 2
        ? enteredYear < 40
          ? 2000 + enteredYear
          : 1900 + enteredYear
        : enteredYear;

    const daysInMonth = new Date(year, month, 0).getDate();
    if (month < 1 || month > 12 || day < 1 || day > daysInMonth) {
      return null;
    }

    const date = this.createDate(year, month - 1, day);
    return this.isValid(date) && date.getDate() === day ? date : null;
  }
}
